import DOMPurify from 'dompurify';

const sanitizeHTML = (htmlString: string | undefined | null) => {
  if (!htmlString) {
    return {
      __html: '',
    };
  }
  return {
    __html: DOMPurify.sanitize(htmlString, {
      ADD_ATTR: ['target', 'rel', 'class', 'id'],
      ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'width', 'height', 'target', 'rel', 'class', 'id'],
    }),
  };
};

export default sanitizeHTML;
